.yearsList {
  border-collapse: collapse;
  border-width: 0;

  &[data-full-width] {
    width: 100%;
  }
}

.yearsListCell {
  padding: 0;

  &:where([data-with-spacing]) {
    padding: 0.5px;
  }
}
